import { ApolloClientFactory } from '../domain/apolloClientFactory';
import { action, computed, observable, toJS } from 'mobx';
import gql from 'graphql-tag';
import { canUseWindow } from '../domain/ssrTools';

export interface IOrder {
  variantId: string;
  quantity: number;
  itemPrice: number;
}

export default class AuthService {
  private static _instance: AuthService;

  @observable
  private _token: string | null;

  @observable
  private _user: GQL.IUser | null = null; // todo: this must be ICustomer !!!

  private _detected: boolean = false;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new AuthService();
    }

    return this._instance;
  }

  public async ensureValidToken() {
    const query = gql`
      query {
        loggedIn
      }
    `;

    let isTokenValid = true;

    try {
      const result = await ApolloClientFactory.GetClient().query({ query, fetchPolicy: 'network-only' });

      if (!(result.data as any).loggedIn) {
        isTokenValid = false;
      }
    } catch (e) {
      isTokenValid = false;
    }

    if (!isTokenValid) {
      this.removeToken();
    }
  }

  @computed
  public get loggedIn() {
    return this._token != undefined;
  }

  @computed
  public get token() {
    return this._token;
  }

  @computed
  public get notDetected() {
    return this._detected === false;
  }

  @action
  public setLogin(login: { token: string, user: GQL.IUser }) {
    this._token = login.token;
    this._user = login.user;
    this._detected = true;
    if (canUseWindow()) {
      localStorage.setItem('token', login.token);

      // Show the customs NoticeBar again after every new login
      try {
        localStorage.removeItem('noticeDismissed');
      } catch (e) {
        // ignore
      }
    }
  }

  @action
  public removeToken() {
    this._token = null;
    this._user = null;
    this.setCustomer(null);
    if (canUseWindow()) {
      localStorage.removeItem('token');
    }
  }

  @action
  public setCustomer(customer: GQL.IUser | null) {
    const thisUser = this._user;
    if (JSON.stringify(thisUser) != JSON.stringify(customer)) {
      this._user = customer;
    }
    if (this._detected !== true) {
      this._detected = true;
    }
  }

  @computed
  public get customer() {
    return toJS(this._user);
  }

  @computed
  public get customerGroupId() {
    const customer = toJS(this._user);
    if (customer && customer.customerGroups && Array.isArray(customer.customerGroups)) {
      const customerGroupIds = customer.customerGroups.map((cg) => cg.id);

      if (customer.customerGroup && customer.customerGroup.id) {
        customerGroupIds.push(customer.customerGroup.id);
      }

      return customerGroupIds;
    }

    if (customer && customer.customerGroup && customer.customerGroup.id) {
      return customer.customerGroup.id;
    }

    return null;
  }

  private initialize() {
    this._token = localStorage.getItem('token');
  }

  private constructor() {
    this.initialize();
    this.ensureValidToken();
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.ts